import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ErrorService} from '@app/services';
import {PointOfInterestSearchParams} from '../point-of-interest-search-params';
import {PointOfInterestService} from '../point-of-interest.service';
@Component({
  selector: 'hpf-point-of-interest-count',
  templateUrl: './point-of-interest-count.component.html'
})
export class PointOfInterestCountComponent implements OnInit {
  /** The filters */
  @Input() searchParams: PointOfInterestSearchParams = new PointOfInterestSearchParams();
  /** Count result */
  count: number;
  /** Load flag */
  loaded = false;
  /** Constructor */
  constructor(private pointOfInterestService: PointOfInterestService,
              private errorService: ErrorService) {}
  /** Init */
  ngOnInit() {
    this.pointOfInterestService.count(this.searchParams.toObject())
    .then((count) => {
      this.count = count;
      this.loaded = true;
    })
    .catch((error) => this.errorService.handle(error))
  }
}
